export default __webpack_public_path__ + "static/media/1885.8f837791.png";